import dict from '@/store/dict/maintenanceOrder'
import { getOrderRefundListApi } from './services'
import { operateMaxShowLength } from '@/store/dict/config'

const {
  examStates,
  refundTypes,
  refundStates,
  itemType,
  refundSources,
} = dict
export default function () {
  const configData = {
    formData: {
      formProps: {
        model: {
          businessType: 300,
        },
      },
      list: [
        {
          el: 'input',
          itemConfig: {
            label: '父单ID',
            prop: 'parentOrderId',
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '子单ID',
            prop: 'orderId',
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '手机号',
            prop: 'userNumber',
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '退款类型',
            prop: 'refundType',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(refundTypes, true),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '退款状态',
            prop: 'refundState',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(refundStates, true),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '维保服务商名称(ID)',
            prop: 'tenantId',
          },
          elConfig: {
            options: {
              label: 'tenantName',
              value: 'tenantId',
              list: [],
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '审核状态',
            prop: 'examState',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(examStates, true),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '退款来源',
            prop: 'refundSource',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(refundSources, true),
            },
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '退款时间',
            prop: 'createTime',
          },
          elConfig: {
            clearable: true,
          },
        },
      ],
      dealWithSearch: this.search,
    },
    tableData: {
      columns: [
        {
          name: 'parentOrderId',
          columnProps: {
            label: '父单ID',
            prop: 'parentOrderId',
          },
        },
        {
          name: 'orderId',
          columnProps: {
            label: '子单ID',
            prop: 'orderId',
          },
        },
        {
          name: 'refundTradeId',
          columnProps: {
            label: '退款交易流水号',
            prop: 'refundTradeId',
          },
        },
        {
          name: 'refundState',
          columnProps: {
            label: '退款状态',
            prop: 'refundState',
            formatter: (row) => {
              return refundStates[row.refundState] || '--'
            },
          },
        },
        {
          name: 'remark',
          columnProps: {
            label: '退款原因',
            prop: 'remark',
            width: 120,
          },
        },
        {
          name: 'tenantId',
          columnProps: {
            label: '服务商ID',
            prop: 'tenantId',
            width: 120,
          },
        },
        {
          name: 'tenantName',
          columnProps: {
            label: '服务商名称',
            prop: 'tenantName',
            width: 120,
          },
        },
        {
          name: 'itemType',
          columnProps: {
            label: '订单类型',
            prop: 'itemType',
            width: 120,
            formatter: (row) => {
              return itemType[row.itemType] || '--'
            },
          },
        },
        {
          name: 'createUser',
          columnProps: {
            label: '申请人',
            prop: 'createUser',
            width: 120,
          },
        },
        {
          name: 'refundType',
          columnProps: {
            label: '退款类型',
            prop: 'refundType',
            width: 120,
            formatter: (row) => {
              return refundTypes[row.refundType] || '--'
            },
          },
        },
        {
          name: 'examState',
          columnProps: {
            label: '审核状态',
            prop: 'examState',
            width: 120,
            formatter: (row) => {
              return examStates[row.examState] || '--'
            },
          },
        },
        {
          name: 'refundSource',
          columnProps: {
            label: '退款来源',
            prop: 'refundSource',
            width: 120,
            formatter: (row) => {
              return refundSources[row.refundSource] || '--'
            },
          },
        },
        {
          name: 'refundAmount',
          columnProps: {
            label: '退款总金额',
            prop: 'refundAmount',
            width: 120,
          },
        },
        {
          name: 'refundGoodsAmount',
          columnProps: {
            label: '商品退款金额',
            prop: 'refundGoodsAmount',
            width: 120,
          },
        },
        {
          name: 'refundPlatformServiceFee',
          columnProps: {
            label: '服务费退款金额',
            prop: 'refundPlatformServiceFee',
            width: 120,
          },
        },
        {
          name: 'refundTime',
          columnProps: {
            label: '退款时间',
            prop: 'refundTime',
            width: 180,
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            prop: 'operate',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          getOperateList: ({ row }) => {
            const arr = [
              {
                label: '详情',
                action: () => this.handleGoToDetail(row),
              },
            ]
            return arr
          },
          type: 'operate',
        },
      ],
      apiFn: getOrderRefundListApi,
    },
    isShowDepartment: false,
  }


  return {
    configData,
  }
}
